import * as React from 'react'

// Import Skills styling
import './Skills.css'

interface SkillsProps {
  skill: string
  link: string
}

const SkillsButton: React.ElementType = (props: SkillsProps) => {
  if (props.link) {
    return (
      <a href={props.link} className="btn li-skills">{props.skill}</a>
    )
  } else {
    return (
      <li className="li-skills">{props.skill}</li>
    )
  }
}

export default SkillsButton
